// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"62062596","115":"a44ad65c","218":"63aaa74a","264":"5bee5006","438":"cf50c9f4","453":"8ab44547","523":"33da8d5b","570":"e07d9e54","614":"8c69fb19","703":"a6493e4e","727":"475ddfce","952":"a8997339","988":"54b07593"}[chunkId] + ".chunk.js";
};